import React from 'react'
import ReactDOM from 'react-dom'
import { Router } from 'react-router-dom'
import history from './history'
import AppContainer from './containers/AppContainer'
import configureStore from './store/configureStore'
import { Provider } from 'react-redux'
import registerSW from './registerServiceWorker'
import './styles/App.css'

registerSW()
// wrap your entire app tree in the ErrorTracker provided

ReactDOM.render(
  <Provider store={configureStore}>
    <Router history={history}>
      <AppContainer />
    </Router>
  </Provider>,
  document.getElementById('root')
)

if (module.hot) {
  module.hot.accept('./containers/AppContainer', () => {
    ReactDOM.render(
      <Provider store={configureStore}>
        <Router history={history}>
          <AppContainer />
        </Router>
      </Provider>,
      document.getElementById('root')
    )
  })
}



// WEBPACK FOOTER //
// ./src/index.js